module.exports = __webpack_public_path__ + "img/delete.b729c1ef.svg";